module.exports = __webpack_public_path__ + "media/images/coupon/user-716156d5f60ec16ab408c731a9d01adc.png";